import styled from '@emotion/styled';
import {ESplayCorner} from 'webapp-lib/Components';
import {mixinFocus} from 'webapp-lib/styling';

export const TooltipHeader = styled.div`
  font-size: var(--font-size-default);
  font-weight: var(--font-weight-paragraph-title);
  margin-bottom: var(--gutter-tiny);
  max-width: 320px;
`;

export const TooltipContent = styled.div`
  font-size: var(--font-size-small);
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: justify;
  word-break: break-all;
  max-width: 320px;
`;

export const SplayCorner = styled(ESplayCorner)<{active?: boolean}>`
  border-color: var(--color-core-primary);
  border-left-color: transparent;
  border-bottom-color: transparent;

  :after {
    ${({active}): string =>
      active
        ? ''
        : 'border-top: var(--regular-border-width) solid var(--color-box-border);'}
  }
`;

export const TextContainer = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  flex-grow: 1;
`;

export const StyledTabBarItem = styled.a<{active?: boolean; width?: number}>`
  position: relative;
  box-sizing: border-box;
  user-select: none;
  cursor: pointer;
  min-width: 0;
  flex-basis: ${({width}): string => (width ? `${width}px` : '280px')};
  max-width: ${({width}): string => (width ? `${width}px` : '280px')};
  flex-shrink: 1;
  border: var(--regular-border-width) solid var(--color-core-primary);
  border-bottom: var(--regular-border-width) solid
    ${({active}): string =>
      active ? 'transparent' : 'var(--color-core-primary)'};
  background-color: var(--color-core-white);
  color: var(--color-core-black);
  font-weight: var(--font-weight-thin);
  font-size: var(--font-size-default);
  text-align: left;
  padding: 0 var(--gutter-little) 0 var(--gutter);
  display: flex;
  height: 42px;
  align-items: center;
  margin-bottom: 0;

  &:not(:first-of-type) {
    margin-left: var(--gutter-little);
  }

  &:not(:first-of-type)::after {
    content: '';
    width: 9px;

    border-bottom: var(--regular-border-width) solid var(--color-core-primary);
    position: absolute;
    bottom: -1px;
    left: -10px;
  }

  :focus {
    ${mixinFocus}
  }
`;
